import React, { useState } from "react";
import WsrvImage from "../utils/WsrvImage";

export default function ViedeoSection({ data }) {
  const [isOpen, setIsOpen] = useState(false);
  const [videoId, setVideoId] = useState(null);
  function openVideo(id) {
    setVideoId(id);
    setIsOpen(true);
  }
  return (
    <>
      <div className="video-section mt-16  bg-gradient-to-b from-[#FFD338]  from-[60%] to-white to-[40%] ">
        <div className="container">
          <div className=" flex flex-col container lg:py-4 py-8 px-4 lg:px-0">
            <div className="pb-2">
              <div className="text-center mb-8 ">
                {data?.heading && (
                  <h2 className="text-2xl md:text-[38px] font-bold text-[#163758] mb-4 leading-tight">
                    {data?.heading}..
                  </h2>
                )}
                {data?.subHeading && (
                  <h3 className="text-2xl md:text-[38px] font-bold text-[#163758] leading-tight">
                    {data?.subHeading}
                  </h3>
                )}
              </div>
            </div>

            {/* <div className="mx-auto">
              <img
                src="https://i.filecdn.in/844twof/videoimage-1756372343049.png"
                alt="Video Section Image"
                className="md:w-[861px] md:h-auto w-full h-auto  object-cover object-top rounded-xl"
              />
            </div> */}

            {data?.link && (
              <div className="relative mx-auto md:mt-0 mt-4">
                <WsrvImage
                  src={`https://i.ytimg.com/vi/${data?.link}/hq720.jpg`}
                  alt={data.heading || "Video thumbnail"}
                  width={861}
                  height={485}
                  widths={[320, 480, 640, 750, 828, 861, 1280]}
                  sizes="(max-width: 768px) 100vw, 861px"
                  className="md:w-[861px] md:h-auto w-full h-auto object-cover object-top rounded-xl"
                />
                <div
                  className="absolute w-[40px] md:w-[55px] -translate-x-2/4 -translate-y-2/4 left-2/4 top-2/4 cursor-pointer"
                  onClick={() => openVideo(data?.link)}
                >
                  <WsrvImage
                    src="https://i.filecdn.in/831sgoi/youtube-1700310763224.png"
                    alt="Play video"
                    width={55}
                    height={55}
                    widths={[40, 55, 80]}
                    className="w-full h-auto"
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {isOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/80 z-[9999] p-4">
          <div className="bg-transparent relative rounded-lg max-w-2xl w-full">
            <iframe
              width="100%"
              height="400"
              src={`https://www.youtube.com/embed/${videoId}`}
              title="My video"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope;"
              allowFullScreen
              className="rounded-lg"
            ></iframe>
            <button
              onClick={() => setIsOpen(false)}
              className="absolute top-4 right-4 bg-white text-black px-2 py-1 rounded-full shadow-md hover:bg-gray-300 transition"
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </>
  );
}
